"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoServiceHistoryComponent = void 0;
var core_1 = require("@angular/core");
var fileSaver = require("file-saver");
var _services_1 = require("@/_services");
var vehicle_service_history_service_1 = require("@/_services/vehicle-service-history.service");
var router_1 = require("@angular/router");
var storage_service_1 = require("@/_services/storage-service");
var NoServiceHistoryComponent = /** @class */ (function () {
    function NoServiceHistoryComponent(vehicleServiceHistorysService, authenticationService, userService, activatedRoute, storageService) {
        this.vehicleServiceHistorysService = vehicleServiceHistorysService;
        this.authenticationService = authenticationService;
        this.userService = userService;
        this.activatedRoute = activatedRoute;
        this.storageService = storageService;
        this.currentUser = this.authenticationService.currentUserValue;
        this.currentBp = this.authenticationService.currentBpValue;
    }
    NoServiceHistoryComponent.prototype.saveFile = function (data, filename) {
        var blob = new Blob([data], { type: 'application/octet-stream' });
        fileSaver.saveAs(blob, filename);
    };
    NoServiceHistoryComponent.prototype.ngOnInit = function () {
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], NoServiceHistoryComponent.prototype, "childVehicleServiceHist", void 0);
    NoServiceHistoryComponent = __decorate([
        core_1.Component({
            selector: 'no-service-history',
            template: require('./noservicehistory.component.html')
        }),
        __metadata("design:paramtypes", [vehicle_service_history_service_1.VehicleServiceHistorysService,
            _services_1.AuthenticationService,
            _services_1.UserService,
            router_1.ActivatedRoute, storage_service_1.StorageService])
    ], NoServiceHistoryComponent);
    return NoServiceHistoryComponent;
}());
exports.NoServiceHistoryComponent = NoServiceHistoryComponent;
